<script>
import Breadcrumb from "../../geral/Breadcrumb.vue";
import jsQR from "jsqr";
import {showToast} from "../../../admin/utils";
import certificadosDigitais from "../../../api/certificados-digitais";
import Btn from "../../_www/Btn/Btn.vue";
import Icon from "../../Icon.vue";

const ETAPAS = Object.freeze({
  SELECIONAR_TRIBUNAL: 'SELECIONAR_TRIBUNAL',
  CONFIGURAR_QR_CODE: 'CONFIGURAR_QR_CODE',
  FINAL: null
});

const MODOS_ENTRADA = Object.freeze({
  CAMERA: 'camera',
  UPLOAD: 'upload',
  MANUAL: 'manual'
});

export default {
  name: "AdicionarMetodoAutenticacao",
  components: {
    Breadcrumb,
    Btn,
    Icon
  },
  props: {
    certificado: {
      type: Object,
      required: true,
      default: () => {
      }
    },
    sistemas: {
      type: Array,
      required: true
    },
    sistemaSelecionado: {
      type: String,
      required: false,
      default: null
    },
  },
  mounted() {
    if (this.sistemaSelecionado) {
      this.etapa = ETAPAS.CONFIGURAR_QR_CODE;
      this.tribunalSelecionado = this.sistemaSelecionado
    }

    this.scrollTo('topo-adicionar-novo-metodo')
  },
  data() {
    return {
      ETAPAS,
      MODOS_ENTRADA,
      tribunalSelecionado: null,
      etapa: ETAPAS.SELECIONAR_TRIBUNAL,
      modoEntrada: MODOS_ENTRADA.UPLOAD,
      imagem: null,
      imagemUrl: null,
      qrCode: {
        resultado: null,
        cpf: null,      // CPF bruto extraído do QR (11 dígitos)
        cpfFormatado: null, // CPF formatado para exibição (XXX.XXX.XXX-XX)
        cpfValido: true,
        error: null,
        loading: false,
      },
      form: {
        secret: null,
        codigoVerificacao: null,
      },
      solicitacao: {
        sucesso: null,
        loading: false
      },
      showCameraView: null,
      showQrGuideBox: null,
      erro: null,
      stream: null,
      animationFrameId: null,
    }
  },
  computed: {
    // ... [Demais computed properties mantidas iguais] ...
    breadcrumbRaiz() {
      const url = window.location.href;
      if (url.includes('/parceiros/')) {
        return {text: 'Tribunais', to: '/parceiros/tribunais'};
      }
      return {text: 'Certificados Digitais', to: '/certificados'};
    },
    linkListagem() {
      const urlAtual = window.location.href;
      const palavraChave = '/metodos-autenticacao';
      const indice = urlAtual.indexOf(palavraChave);
      if (indice !== -1) {
        return urlAtual.substring(0, indice + palavraChave.length);
      }
      return `/certificados/${this.certificado.id}/metodos-autenticacao`;
    },
    formInvalido() {
      if (this.etapa === ETAPAS.SELECIONAR_TRIBUNAL) {
        return this.tribunalSelecionado === null;
      }
      if (this.etapa === ETAPAS.CONFIGURAR_QR_CODE) {
        if (!this.qrCode.cpfValido) {
          return true;
        }
        const secretValido = !!this.form.secret && this.form.secret.length > 0;
        const codigoValido = !!this.form.codigoVerificacao && this.form.codigoVerificacao.length === 6;
        return !secretValido || !codigoValido;
      }
      return false;
    },
    mensagemResultadoQrcode() {
      if (this.qrCode.loading) {
        return 'Processando imagem...'
      } else if (this.qrCode.resultado && !this.qrCode.cpfValido) {
        return 'CPF do QR Code diverge do Certificado';
      } else if (this.qrCode.resultado) {
        return 'Código escaneado com sucesso'
      } else if (this.qrCode.error) {
        return this.qrCode.error
      } else {
        return null;
      }
    },
    isEditar() {
      return this.sistemaSelecionado;
    },
    passos() {
      if (this.isEditar) {
        return [
          {nome: ETAPAS.CONFIGURAR_QR_CODE, titulo: 'Configuração do Segredo (TOTP)', numero: 1}
        ];
      } else {
        return [
          {nome: ETAPAS.SELECIONAR_TRIBUNAL, titulo: 'Selecione o Tribunal e Sistema', numero: 1},
          {nome: ETAPAS.CONFIGURAR_QR_CODE, titulo: 'Configuração do Segredo (TOTP)', numero: 2}
        ];
      }
    },
    passoAtual() {
      return this.passos.find(p => p.nome === this.etapa);
    },
    passoAtualIndex() {
      return this.passos.findIndex(p => p.nome === this.etapa);
    },
    titulo() {
      return `${this.isEditar ? 'Editar' : 'Adicionar Novo'} Método de Autenticação`;
    },
  },
  watch: {
    modoEntrada(novoModo) {
      this.resetarQrCode();
      if (novoModo === MODOS_ENTRADA.CAMERA) {
        this.abrirCamera();
      } else {
        this.fecharCamera();
      }
    }
  },
  methods: {
    // --- MÉTODOS AUXILIARES DE FORMATAÇÃO E VALIDAÇÃO ---

    // Remove tudo que não é dígito
    limparStringNumerica(str) {
      return str ? str.replace(/\D/g, '') : '';
    },

    // Formata 12345678900 para 123.456.789-00
    formatarCpfParaExibicao(cpfNumerico) {
      if (!cpfNumerico) return '';
      return cpfNumerico.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },

    // Extrai o CPF (apenas números) da URL do QR Code
    extrairCpfDoQrCode(urlObj) {
      try {
        // Decodifica a URL (ex: .../PDPJ:12345678900...)
        const path = decodeURIComponent(urlObj.pathname);
        const partes = path.split(':');

        if (partes.length > 1) {
          // Pega a última parte após o ':'
          const possivelCpf = partes[partes.length - 1].trim();
          const apenasNumeros = this.limparStringNumerica(possivelCpf);

          // Validação básica de tamanho
          if (apenasNumeros.length === 11) {
            return apenasNumeros;
          }
        }
        return null;
      } catch (e) {
        console.error('Erro ao extrair CPF', e);
        return null;
      }
    },

    // Lógica Central de Comparação
    validarCpfCompativel(cpfQrFull, cpfCertMascarado) {
      // 1. Limpa os dados
      const cpfQrNumeros = this.limparStringNumerica(cpfQrFull); // Ex: "12354416599"

      // O certificado vem como "XXX.544.165-XX", limpando vira "544165"
      let cpfCertNumeros = this.limparStringNumerica(cpfCertMascarado);

      // Caso o certificado venha completo (edge case), pegamos o meio dele também
      if (cpfCertNumeros.length === 11) {
        cpfCertNumeros = cpfCertNumeros.substring(3, 9);
      }

      // 2. Extrai o "miolo" do CPF do QR Code (índices 3 a 9 = dígitos 4 a 9)
      // 123[544165]99
      // 012 345678 90
      const cpfQrMiolo = cpfQrNumeros.substring(3, 9);

      // 3. Compara
      return cpfQrMiolo === cpfCertNumeros;
    },

    // ---------------------------------------------------

    setModoEntrada(modo) {
      this.modoEntrada = modo;
    },
    // ... [getTribunalPorId, scrollTo, proximaEtapa, voltarParaPaginaGerenciar mantidos] ...
    getTribunalPorId(id) {
      return this.sistemas.filter(tribunal => tribunal.id === id)[0];
    },
    scrollTo(elementId) {
      const el = document.getElementById(elementId);
      if (el) el.scrollIntoView({behavior: 'smooth'});
    },
    proximaEtapa() {
      const proximoPasso = this.passos[this.passoAtualIndex + 1];

      if (proximoPasso) {
        this.etapa = proximoPasso.nome;
        if (this.etapa === ETAPAS.CONFIGURAR_QR_CODE) {
          this.modoEntrada = MODOS_ENTRADA.UPLOAD;
        }
        this.scrollTo('topo-adicionar-novo-metodo');
      } else {
        this.etapa = ETAPAS.FINAL;
        this.scrollTo('topo-adicionar-novo-metodo');
      }
    },
    voltarParaPaginaGerenciar() {
      window.location.href = this.linkListagem;
    },
    voltar() {
      const passoAnterior = this.passos[this.passoAtualIndex - 1];

      if (this.etapa === ETAPAS.FINAL) {
        this.etapa = ETAPAS.CONFIGURAR_QR_CODE;
        this.modoEntrada = MODOS_ENTRADA.UPLOAD;
        return;
      }

      if (passoAnterior) {
        this.etapa = passoAnterior.nome;
        if (this.etapa !== ETAPAS.CONFIGURAR_QR_CODE) {
          this.fecharCamera();
          this.resetarEtapaTOTP();
        }
        this.scrollTo('topo-adicionar-novo-metodo');
      } else {
        this.voltarParaPaginaGerenciar();
      }
    },

    // ... [abrirCamera, fecharCamera, scanearQRCodeDaCamera, handleFileUpload, carregarCanvas, carregarImagem mantidos] ...
    async abrirCamera() {
      if (this.modoEntrada !== MODOS_ENTRADA.CAMERA) return;

      this.resetarQrCode();
      this.qrCode.loading = true;
      this.showCameraView = true;
      this.showQrGuideBox = true;

      try {
        this.stream = await navigator.mediaDevices.getUserMedia({video: {facingMode: 'environment'}});

        this.$nextTick(async () => {
          if (this.$refs.videoRef) {
            this.$refs.videoRef.srcObject = this.stream;
            this.$refs.videoRef.setAttribute('playsinline', true);
            await this.$refs.videoRef.play();
            this.scanearQRCodeDaCamera();
          }
        });
      } catch (err) {
        showToast(
          "Falha ao acessar a câmera. Verifique permissões ou use o Upload/Digitação Manual.",
          {type: 'error'}
        );
        this.qrCode.loading = false;
        this.fecharCamera();
      }
    },
    fecharCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
      if (this.$refs.videoRef) {
        this.$refs.videoRef.srcObject = null;
      }
      this.showCameraView = false;
      this.showQrGuideBox = false;
      this.qrCode.loading = false;
    },
    scanearQRCodeDaCamera() {
      if (!this.showCameraView || this.modoEntrada !== MODOS_ENTRADA.CAMERA) {
        return;
      }

      if (!this.$refs.videoRef || this.$refs.videoRef.readyState !== this.$refs.videoRef.HAVE_ENOUGH_DATA) {
        this.animationFrameId = requestAnimationFrame(() => this.scanearQRCodeDaCamera());
        return;
      }

      const imageData = this.carregarCanvas(this.$refs.videoRef);
      const code = jsQR(imageData.data, imageData.width, imageData.height, {inversionAttempts: 'dontInvert'});
      this.processarCodigo(code);
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        showToast('Nenhum arquivo foi selecionado', {type: 'error'});
        return;
      }
      this.imagem = file;
      this.qrCode.loading = true;
      try {
        const image = await this.carregarImagem(file);
        const imageData = this.carregarCanvas(image);
        const code = jsQR(imageData.data, imageData.width, imageData.height, {inversionAttempts: 'dontInvert'});
        this.processarCodigo(code)
      } catch (err) {
        showToast("Erro ao processar a imagem", {type: 'error'})
        this.resetarQrCode()
      } finally {
        this.qrCode.loading = false;
      }
    },
    carregarCanvas(image) {
      const canvas = this.$refs.qrCanvasRef;
      if (!canvas) return {data: [], width: 0, height: 0};
      const ctx = canvas.getContext('2d', {willReadFrequently: true});
      const maxSize = 1000;
      const ratio = Math.min(maxSize / image.width, maxSize / image.height);
      if (image.videoWidth) {
        canvas.width = image.videoWidth;
        canvas.height = image.videoHeight;
      } else {
        canvas.width = image.width * ratio;
        canvas.height = image.height * ratio;
      }
      ctx.drawImage(image, 0, 0);
      return ctx.getImageData(0, 0, canvas.width, canvas.height);
    },
    carregarImagem(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          URL.revokeObjectURL(img.src);
          resolve(img)
        };
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
      });
    },

    processarCodigo(codigo) {
      if (codigo) {
        codigo = codigo.data;
        const valido = this.validarCodigo(codigo);

        if (!valido) {
          if (this.modoEntrada === MODOS_ENTRADA.CAMERA) {
            this.animationFrameId = requestAnimationFrame(() => this.scanearQRCodeDaCamera());
            return;
          }
          showToast("QR Code inválido ou não encontrado", {type: 'error'});
          return;
        }

        // --- VALIDAÇÃO DE CPF (PARCIAL) ---
        try {
          const urlObj = new URL(codigo);
          this.form.secret = urlObj.searchParams.get('secret');

          // 1. Extrai CPF do QR
          const cpfDoQrCode = this.extrairCpfDoQrCode(urlObj);

          if (cpfDoQrCode) {
            // Salva para exibição (formatado) e raw
            this.qrCode.cpf = cpfDoQrCode;
            this.qrCode.cpfFormatado = this.formatarCpfParaExibicao(cpfDoQrCode);

            // 2. Compara os 6 digitos do meio
            const cpfCompativel = this.validarCpfCompativel(cpfDoQrCode, this.certificado.pessoa_cpf);

            if (!cpfCompativel) {
              this.qrCode.cpfValido = false;
              showToast("CPF do QR Code diverge do Certificado!", {type: 'error'});

              if (this.modoEntrada === MODOS_ENTRADA.CAMERA) {
                this.fecharCamera();
                if (this.$refs.qrCanvasRef) {
                  this.imagemUrl = this.$refs.qrCanvasRef.toDataURL('image/png');
                }
              } else if (this.imagem) {
                this.imagemUrl = URL.createObjectURL(this.imagem);
              }

              this.qrCode.resultado = codigo;
              return; // Bloqueia
            }
          }

          // Validação passou ou CPF não encontrado no QR (genérico)
          this.qrCode.cpfValido = true;
          showToast('Código escaneado com sucesso!');

        } catch (e) {
          console.error("Erro ao processar URL do QR", e);
          this.resetarQrCode();
          showToast("QR Code mal formatado.", {type: 'error'});
          return;
        }
        // --- FIM VALIDAÇÃO ---

        this.qrCode.resultado = codigo;

        this.$nextTick(() => {
          const inputCode = document.querySelector('input[name="totp_code"]');
          if (inputCode) inputCode.focus();
        });

        if (this.modoEntrada === MODOS_ENTRADA.CAMERA) {
          this.fecharCamera();
          if (this.$refs.qrCanvasRef) {
            this.imagemUrl = this.$refs.qrCanvasRef.toDataURL('image/png');
          }
        } else if (this.imagem) {
          this.imagemUrl = URL.createObjectURL(this.imagem);
        }

        return;
      }

      if (this.modoEntrada === MODOS_ENTRADA.CAMERA && !codigo) {
        this.animationFrameId = requestAnimationFrame(() => this.scanearQRCodeDaCamera());
        return;
      }

      if (!codigo) {
        showToast("QR Code inválido ou não encontrado", {type: 'error'});
        this.resetarQrCode();
      }
    },

    adicionarNovoMetodo() {
      this.solicitacao.loading = true;
      this.erro = null;

      if (!this.form.secret) {
        showToast("Chave secreta (Secret) não identificada.", {type: 'error'});
        this.solicitacao.loading = false;
        return;
      }

      // Bloqueio extra no submit
      if (!this.qrCode.cpfValido) {
        showToast("CPF do QR Code diverge do certificado.", {type: 'error'});
        this.solicitacao.loading = false;
        return;
      }

      let data = {
        "codigo_verificacao": this.form.codigoVerificacao,
        "secret": this.form.secret,
      };

      const tribunalEncontrado = this.sistemas.find(t => t.id === this.tribunalSelecionado);

      if (tribunalEncontrado) {
        data['origem_tribunal_sistema_ids'] = tribunalEncontrado.ids;
      } else {
        showToast("Ocorreu um erro ao selecionar o tribunal. Tente novamente.", {type: 'error'});
        this.solicitacao.loading = false;
        return;
      }

      certificadosDigitais.adicionarMetodoAutenticacao(this.certificado.id, data)
        .then(() => {
          this.solicitacao.sucesso = true
        })
        .catch((err) => {
          this.solicitacao.sucesso = false;
          let msg = "Ocorreu um erro inesperado ao verificar o código.";

          if (err.response && err.response.data) {
            if (err.response.data.error) {
              msg = err.response.data.error;
            } else if (err.response.data.message) {
              msg = err.response.data.message;
            }
          }

          this.erro = msg;
        })
        .finally(() => {
          this.proximaEtapa();
          this.solicitacao.loading = false;
        })
    },
    validarCodigo(codigo) {
      try {
        let secret = new URL(codigo).searchParams.get('secret')
        return secret && secret.length >= 16;
      } catch {
        return false;
      }
    },
    voltarNovoTOTP() {
      this.voltar();
      this.resetarEtapaTOTP();
    },
    resetarQrCode() {
      this.qrCode.resultado = null;
      this.qrCode.cpf = null;
      this.qrCode.cpfFormatado = null;
      this.qrCode.cpfValido = true;
      this.form.secret = null;
      this.imagem = null;
      if (this.imagemUrl) {
        URL.revokeObjectURL(this.imagemUrl);
      }
      this.imagemUrl = null;
      this.resetarValoresObjeto(this.qrCode);
      this.qrCode.cpfValido = true; // Garante reset do erro
    },
    resetarEtapaTOTP() {
      this.resetarQrCode();
      this.resetarValoresObjeto(this.form);
      this.modoEntrada = MODOS_ENTRADA.UPLOAD;
    },
    resetarValoresObjeto(obj) {
      Object.getOwnPropertyNames(obj).forEach(key => {
        if(key !== 'cpfValido') obj[key] = null;
      });
    }
  },
  beforeDestroy() {
    this.fecharCamera();
    this.resetarQrCode();
  },
}
</script>

<template>
  <div id="topo-adicionar-novo-metodo" class="col-sm-10">
    <Breadcrumb :items="[
        breadcrumbRaiz,
        { text: certificado['pessoa_nome'].toUpperCase(), to: linkListagem },
        { text: (`${this.isEditar ? 'Editar' : 'Adicionar novo' } método` ) , active: true }
      ]"/>

    <h1 class="text-2xl font-bold m-0">{{ titulo }}</h1>
    <div class="mt">
      <div v-if="etapa !== ETAPAS.FINAL">
        <div class="bg-white shadow p-4 rounded-md mb-6 border border-gray-200">
          <p class="text-gray-600 m-0">
            <strong>Certificado:</strong>
            <span>
              {{ certificado['pessoa_nome'].toUpperCase() }}  ({{ certificado['pessoa_cpf'] }})
            </span>
          </p>
        </div>

        <div class="mb-4">
          <h2 class="text-xl m-0">Passo {{ passoAtual.numero }} de {{ passos.length }}: {{ passoAtual.titulo }}</h2>
        </div>
      </div>

      <template v-if="etapa === ETAPAS.SELECIONAR_TRIBUNAL">
        <div class="form-box space-y-2">
          <label for="tribunalSistema" class="text-sm font-semibold">Tribunal + Sistema *</label>
          <select
            name="tribunalSistema"
            id="tribunalSistema"
            v-model="tribunalSelecionado"
            class="field px-3 rounded-md text-sm form-control max-width-responsiva"
          >
            <option :value="null" selected>
              Selecione o tribunal e sistema
            </option>
            <option v-for="tribunal in sistemas" :key="tribunal.id" :value="tribunal.id">
              {{ tribunal.nome }}
            </option>
          </select>
        </div>

        <div class="mt-4">
          <Btn class="btn negative" @click="voltar">Cancelar</Btn>
          <Btn class="btn info" :disabled="formInvalido" @click="proximaEtapa">Próximo</Btn>
        </div>
      </template>

      <template v-if="etapa === ETAPAS.CONFIGURAR_QR_CODE">

        <div v-if="!qrCode.cpfValido" class="mb-6 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
          <strong class="font-bold flex items-center gap-2">
            <icon name="close-circle" class="w-5 h-5" />
            CPF Incompatível
          </strong>
          <div class="mt-2 text-sm text-gray-800">
            <p>O QR Code escaneado pertence ao CPF:
              <strong class="font-mono bg-red-200 px-1 rounded">{{ qrCode.cpfFormatado }}</strong>
            </p>
            <p class="mt-1">
              Mas o certificado pertence ao CPF:
              <strong class="font-mono bg-red-200 px-1 rounded">{{ certificado.pessoa_cpf }}</strong>
            </p>
          </div>
          <p class="mt-3 text-sm">Por favor, gere um novo QR Code no tribunal utilizando a conta do titular do certificado.</p>

          <button @click="resetarQrCode" class="mt-3 text-sm underline text-red-800 hover:text-red-900 font-bold uppercase tracking-wide">
            Escanear outro código
          </button>
        </div>

        <section class="border-b mb-6 pb-6" :class="{ 'opacity-50 pointer-events-none': !qrCode.cpfValido && qrCode.resultado }">
          <h3 class="text-lg text-gray-700 mb-2 font-semibold">
            A. Obtenha a Chave Secreta (QR Code)
          </h3>
          <p class="text-gray-600 mb-4">
            No sistema <span class="font-semibold">{{ tribunalSelecionado }}</span>,
            localize a opção de configurar autenticação de dois fatores (TOTP).
            <a target="_blank"
               href="https://suporte-api.escavador.com/hc/pt-br/articles/39344638701211-Como-Obter-o-QR-Code-para-Autentica%C3%A7%C3%A3o-Multifator-MFA-no-EPROC"
               class="ml-1 underline text-blue-500 hover:text-blue-600">
              Ajuda
            </a>
          </p>

          <div class="flex border-b border-gray-200 mb-4">
            <button
              @click="setModoEntrada(MODOS_ENTRADA.UPLOAD)"
              :class="{'border-blue-500 text-blue-800 font-semibold': modoEntrada === MODOS_ENTRADA.UPLOAD}"
              class="flex-1 py-3 text-center text-sm sm:text-base text-gray-600 border-b-2 border-transparent hover:bg-gray-50 transition-colors"
            >
              <icon name="upload" class="inline-block mr-1 h-4 w-4"></icon>
              Fazer Upload
            </button>
            <button
              @click="setModoEntrada(MODOS_ENTRADA.CAMERA)"
              :class="{'border-blue-500 text-blue-800 font-semibold': modoEntrada === MODOS_ENTRADA.CAMERA}"
              class="flex-1 py-3 text-center text-sm sm:text-base text-gray-600 border-b-2 border-transparent hover:bg-gray-50 transition-colors"
            >
              <icon name="camera" class="inline-block mr-1 h-4 w-4"></icon>
              Escanear Câmera
            </button>
            <button
              @click="setModoEntrada(MODOS_ENTRADA.MANUAL)"
              :class="{'border-blue-500 text-blue-800 font-semibold': modoEntrada === MODOS_ENTRADA.MANUAL}"
              class="flex-1 py-3 text-center text-sm sm:text-base text-gray-600 border-b-2 border-transparent hover:bg-gray-50 transition-colors"
            >
              <icon name="keyboard" class="inline-block mr-1 h-4 w-4"></icon>
              Digitar Chave
            </button>
          </div>

          <div v-if="modoEntrada === MODOS_ENTRADA.UPLOAD" class="py-4">
            <label
              class="flex flex-col items-center justify-center h-56 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition duration-150 p-4">
              <div v-if="!qrCode.resultado">
                <div class="flex flex-col items-center">
                  <icon name="upload" style="width: 40px; height: 40px;" class="text-gray-400 mb-2"></icon>
                  <p class="mb-2 text-sm text-gray-500"><span class="font-semibold">Clique para fazer upload</span> da
                    imagem do QR Code</p>
                  <p class="text-xs text-gray-500">PNG, JPG (Máx. 5MB)</p>
                </div>
              </div>
              <div v-else class="flex flex-col items-center text-green-600">
                <icon name="check" style="width: 40px; height: 40px;" class="mb-2"></icon>
                <p class="font-semibold">Arquivo processado com sucesso!</p>
                <p class="text-xs text-gray-500 break-all mt-1">Chave extraída.</p>
              </div>

              <input
                type="file"
                accept="image/png, image/jpeg"
                class="hidden"
                @change="handleFileUpload"
              >
            </label>
            <canvas ref="qrCanvasRef" class="hidden"></canvas>
          </div>

          <div v-if="modoEntrada === MODOS_ENTRADA.CAMERA" class="flex flex-col items-center">
            <div class="preview-box flex flex-col text-center w-full md:w-3/4">
              <div
                class="bg-gray-900 rounded-lg overflow-hidden relative min-h-[300px] flex items-center justify-center">
                <video
                  v-show="showCameraView"
                  ref="videoRef"
                  id="video"
                  class="w-full h-full object-cover absolute inset-0"
                ></video>
                <img
                  v-if="!showCameraView && imagemUrl"
                  :src="imagemUrl"
                  class="w-full h-full object-cover absolute inset-0"
                  alt="QR Code Capturado"
                >
                <div v-if="showQrGuideBox" class="qr-guide-box z-10"></div>
                <div v-if="!showCameraView && !imagemUrl" class="z-10 text-gray-400 p-4">
                  <p>Clique em "Escanear Câmera" na aba acima para iniciar.</p>
                </div>
                <div v-if="qrCode.loading" class="z-20 bg-black bg-opacity-50 px-4 py-2 rounded text-white">
                  Processando...
                </div>
              </div>

              <canvas ref="qrCanvasRef" class="hidden"></canvas>

              <p v-if="qrCode.resultado && qrCode.cpfValido" class="mt-2 text-green-600 font-semibold">
                QR Code detectado com sucesso!
              </p>
            </div>
          </div>

          <div v-if="modoEntrada === MODOS_ENTRADA.MANUAL" class="py-4">
            <div class="form-box space-y-2">
              <label for="manual-secret" class="text-sm font-semibold text-gray-700">Chave Secreta (Secret Key)</label>
              <input
                id="manual-secret"
                type="text"
                v-model="form.secret"
                class="field px-4 py-3 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 outline-none transition form-control"
                placeholder="Ex: JBSWY3DPK3VWWK3TOFRVGCK..."
                autocomplete="off"
              >
              <p class="text-xs text-gray-500">
                Insira o código alfanumérico fornecido pelo sistema caso não consiga ler o QR Code.
              </p>
            </div>
          </div>

        </section>

        <section id="b-codigo-verificacao-totp" :class="{ 'opacity-50 pointer-events-none': !qrCode.cpfValido }">
          <h3 class="text-lg text-gray-700 mb-2 font-semibold">
            B. Confirme a Configuração
          </h3>
          <p class="text-gray-600 mb-3">
            Insira o código de 6 dígitos gerado pelo seu aplicativo autenticador para confirmar.
          </p>

          <div class="form-box space-y-2">
            <label class="text-sm font-semibold"> Código de Verificação (6 dígitos) </label>
            <input
              name="totp_code"
              v-model="form.codigoVerificacao"
              class="input is-large px-2 rounded-md block form-control max-width-responsiva text-center tracking-widest font-mono text-lg"
              type="text"
              style="font-size: 1.1rem;"
              required="required"
              placeholder="000000"
              maxlength="6"
              :disabled="!qrCode.cpfValido"
            />
          </div>
        </section>

        <div class="mt-6 flex flex-wrap gap-2.5 border-t pt-4">
          <Btn
            class="btn negative"
            @click="voltar"
            :disabled="solicitacao.loading"
          >
            Voltar
          </Btn>
          <Btn
            class="btn info"
            type="button"
            :loading="solicitacao.loading"
            :disabled="formInvalido || solicitacao.loading"
            @click="adicionarNovoMetodo"
          >
            Verificar e Salvar
          </Btn>
        </div>
      </template>

      <template v-if="etapa === ETAPAS.FINAL">
        <div class="mb-4 text-center" v-if="solicitacao.sucesso">
          <div class="flex justify-center mb-4 mt-6">
            <span class="bg-green-600 p-1 rounded-3xl">
                <icon name="check" style="width: 48px;height: 48px;" class="-highlight"></icon>
            </span>
          </div>
          <h2 class="text-2xl font-bold text-gray-800">
            Autenticação Configurada com Sucesso!
          </h2>
          <p class="text-base text-gray-600 mt-2">
            O método de autenticação TOTP para o sistema <strong>{{ tribunalSelecionado }}</strong> no certificado
            '{{ certificado['pessoa_nome'].toUpperCase() }}' foi configurado.
          </p>
          <div class="mt-6">
            <Btn class="btn info" @click="voltarParaPaginaGerenciar">Concluído</Btn>
          </div>
        </div>

        <div class="mb-4 text-center" v-else>
          <div class="flex justify-center mb-4 mt-6">
            <span class="p-2 rounded-3xl">
                <icon name="close-circle" style="width: 48px;height: 48px;" class="-negative -highlight"></icon>
            </span>
          </div>

          <h2 class="text-2xl font-bold text-red-600 mb-4">
            {{ erro }}
          </h2>

          <div class="bg-red-50 border border-red-100 rounded-md p-4 text-left mx-auto max-w-lg">
            <p class="text-sm font-semibold text-red-800 mb-2">Para resolver, verifique os pontos abaixo:</p>
            <ul class="checklist-erro list-disc pl-5 space-y-2 text-sm text-gray-700">
              <li>Origem do QR Code incorreta.</li>
              <li>Código do autenticador expirado.</li>
              <li>Relógio do celular fora de sincronia.</li>
            </ul>
          </div>

          <div class="flex flex-wrap gap-2.5 justify-center mt-6">
            <Btn class="btn info" @click="voltar">Tentar novamente</Btn>
            <Btn class="btn negative" @click="voltarParaPaginaGerenciar">Cancelar</Btn>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped lang="stylus">
.checklist-erro
  list-style-type disc !important
  padding-left 20px !important
  margin-top 10px !important

  li
    display list-item !important
    list-style-type disc !important
    margin-bottom 8px

.preview-box
  width 100%
  justify-self center

#video
  display: block;
  object-fit: cover;

.qr-guide-box
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  height: 70%;
  border: 3px solid #10B981;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  border-radius 8px

.field
  @apply border-gray-300

.tab-active
  @apply border-blue-500 text-blue-800 font-semibold
</style>
